import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon, Add } from '@mui/icons-material';
import Toolbar from 'components/Toolbar/Toolbar';
import { isAppAdmin } from 'helpers/permissions';
import UserFilter from './Form/UserFilter';
import UserCreate from './Form/UserCreate';

const UserToolbar = ({
  title = '', isFetching, refetch, backLink, data = null, userData = null
}) => (
  <Toolbar
    title={title}
    backLink={backLink}
    action={(
      <>
        {data && userData && (isAppAdmin(userData.groups) || userData.is_staff)
          ? (
            <UserCreate
              title="Create User"
              button={{
                content: (
                  <>
                    <Add />
                    Create
                  </>
                ),
                color: 'primary',
                variant: 'standard',
                state: 'outlined'
              }}
              handleAssign={!userData.is_staff}
              loggedUserGroups={userData.groups}
            />
          ) : null}
        {isFetching ? (
          <div style={{
            height: 48, width: 48, display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
          >
            <CircularProgress size={22} />
          </div>
        ) : (
          <Tooltip title="Sync">
            <IconButton
              id="SyncButton"
              onClick={(e) => {
                e.preventDefault();
                refetch();
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        )}
        <UserFilter />
      </>
    )}
  />
);
export default UserToolbar;
